import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup-container-form relative" }
const _hoisted_2 = { class: "popup-form" }
const _hoisted_3 = { id: "header-popup-form" }
const _hoisted_4 = { id: "body-popup-form" }

import TitlePage from '@/components/global/title/BaseTitle.vue';


interface Props {
    title: string
    status: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasePopupForm',
  props: {
    title: null,
    status: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'close', payload: MouseEvent): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    title: string
    status: boolean
};






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (__props.status)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"])),
            class: "w-full h-screen bg-[#0000009f] flex flex-col items-center justify-center fixed top-0 left-0 z-10"
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(TitlePage, { text: __props.title }, null, 8, ["text"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _renderSlot(_ctx.$slots, "form")
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})